import { render, staticRenderFns } from "./OrderCardContactInformation.vue?vue&type=template&id=7004c4a7&scoped=true"
import script from "./OrderCardContactInformation.vue?vue&type=script&lang=ts"
export * from "./OrderCardContactInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7004c4a7",
  null
  
)

export default component.exports